import { SELECIONAR_MAPA_VEICULO_AGENDAMENTO_VIAGEM } from '../types'

export default function selecionarMapaVeiculoAgendamentoViagem (assento, fileira) {
  return {
    type: SELECIONAR_MAPA_VEICULO_AGENDAMENTO_VIAGEM,
    payload:{assento, fileira}
  }
}
